import Component from "@glimmer/component"
import styles from "./lesson-title.module.css"

export default class LessonTitleComponent extends Component {
  readonly styles = styles
}
